module.exports = "/assets/data/5881587d80c7f73f5d71fe671415fb3a-SS15.data.json";